import evolutionLogo from "../../Logo/WhatsApp Image 2026-09-02 at 09.19.41.jpeg";

export type SiteImage = {
  src: string;
  srcSet?: string;
  alt: string;
  width: number;
  height: number;
  objectPosition?: string;
  replacementPath: string;
  credit?: {
    name: string;
    url: string;
  };
};

const unsplashImage = ({
  id,
  alt,
  width,
  height,
  objectPosition = "center",
  replacementPath,
  credit,
}: Omit<SiteImage, "src" | "srcSet"> & { id: string }): SiteImage => {
  const baseUrl = `https://images.unsplash.com/photo-${id}`;
  const widths = [640, 960, 1280, 1800];

  return {
    src: `${baseUrl}?auto=format&fit=crop&w=1800&q=82`,
    srcSet: widths
      .map(
        (sourceWidth) =>
          `${baseUrl}?auto=format&fit=crop&w=${sourceWidth}&q=82 ${sourceWidth}w`,
      )
      .join(", "),
    alt,
    width,
    height,
    objectPosition,
    replacementPath,
    credit,
  };
};

/**
 * Registro único de imágenes de la landing.
 *
 * Todas las fotografías remotas son provisionales y deben sustituirse por los
 * archivos indicados en `replacementPath` cuando estén disponibles las fotos
 * reales de Corina. El logo sí es el archivo oficial existente en /Logo.
 */
export const images = {
  logo: {
    src: evolutionLogo,
    alt: "Evolution by Corina",
    width: 1536,
    height: 1024,
    objectPosition: "center 52%",
    replacementPath: "/Logo/WhatsApp Image 2026-09-02 at 09.19.41.jpeg",
  } satisfies SiteImage,
  hero: unsplashImage({
    id: "1485727749690-d091e8284ef3",
    alt: "Fotografía provisional de una mujer estirando en un entorno sereno",
    width: 1800,
    height: 2250,
    objectPosition: "center 46%",
    replacementPath: "/Fotos/hero.webp",
    credit: {
      name: "Emily Sea · Unsplash",
      url: "https://unsplash.com/photos/coiWR0gT8Cw",
    },
  }),
  personalization: unsplashImage({
    id: "1654613412237-54082a661f89",
    alt: "Fotografía provisional de bienestar y movimiento consciente",
    width: 1600,
    height: 2000,
    objectPosition: "center 42%",
    replacementPath: "/Fotos/training-01.webp",
    credit: {
      name: "Volant · Unsplash",
      url: "https://unsplash.com/photos/KOq0TlVQPq8",
    },
  }),
  feature: unsplashImage({
    id: "1575052814074-c05122e0a17a",
    alt: "Fotografía provisional de una sesión de movimiento y acompañamiento",
    width: 2200,
    height: 1320,
    objectPosition: "center 54%",
    replacementPath: "/Fotos/lifestyle-01.webp",
    credit: {
      name: "Carl Barcelo · Unsplash",
      url: "https://unsplash.com/photos/hHzzdVQnkn0",
    },
  }),
  aboutPrimary: unsplashImage({
    id: "1592216269879-6dc441892b52",
    alt: "Retrato editorial provisional; se sustituirá por una fotografía de Corina",
    width: 1600,
    height: 2000,
    objectPosition: "center 40%",
    replacementPath: "/Fotos/corina-01.webp",
    credit: {
      name: "Ba Ba · Unsplash",
      url: "https://unsplash.com/photos/byupxY641UE",
    },
  }),
  aboutSecondary: unsplashImage({
    id: "1770026136404-4262dcabb7b1",
    alt: "Fotografía deportiva provisional; se sustituirá por una fotografía de Corina",
    width: 1400,
    height: 1750,
    objectPosition: "center 34%",
    replacementPath: "/Fotos/corina-02.webp",
    credit: {
      name: "Rodrigo Rodrigues · Unsplash",
      url: "https://unsplash.com/photos/nE1cNBs1PiU",
    },
  }),
} as const;

export type ImageKey = keyof typeof images;
